import { useEffect, useState } from "react";
import { TournamentUserResponse } from "../../../../../api/tournament";
import {
  TournamentItmBack,
  TournamentItmItem,
  TournamentSininWrapper,
} from "../../styled/tournament-itm";
import Pagination from "../../../../../components/web/Pagination";

interface TournamentStateItmProps {
  userList: TournamentUserResponse[];
  type: string;
}
const TournamentStateSitin = ({ userList, type }: TournamentStateItmProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [list, setList] = useState<TournamentUserResponse[]>([]);
  const [more, setMore] = useState<boolean>(false);

  useEffect(() => {
    setTotalPages(Math.max(1, Math.ceil(userList.length / 10)));
    setList(userList.slice((currentPage - 1) * 10, currentPage * 10));
  }, [userList]);

  useEffect(() => {
    setList(userList.slice((currentPage - 1) * 10, currentPage * 10));
  }, [currentPage]);
  return (
    <TournamentSininWrapper>
      <div className="header" onClick={() => setMore(!more)}>
        <div className="title">
          {type === "sitin" ? "싯인" : "싯아웃"} 플레이어
        </div>
        <img
          src={`/image-web/tournament/${more ? "up" : "down"}-arrow.svg`}
          alt="more"
        />
      </div>
      {more && (
        <TournamentItmBack isItm={false}>
          <div className="table">
            <div className="header">
              <div className="item">닉네임</div>
              <div className="item">리엔트리</div>
              <div className="item">애드온</div>
            </div>
            <div className="body">
              {list.length === 0 ? (
                <div className="no-data">플레이어가 없습니다. </div>
              ) : (
                list.map((item, index) => (
                  <TournamentItmItem key={index}>
                    <div className="item">{item.nickname}</div>
                    <div className="item">
                      {item.rebuyCount ? item.rebuyCount.toLocaleString() : "-"}
                    </div>
                    <div className="item">
                      {item.addonCount ? item.addonCount.toLocaleString() : "-"}
                    </div>
                  </TournamentItmItem>
                ))
              )}
            </div>
          </div>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
              size={22}
            ></Pagination>
          )}
        </TournamentItmBack>
      )}
    </TournamentSininWrapper>
  );
};
export default TournamentStateSitin;
